/** COPYRIGHT NOTICE
 *
 *  Copyright (C) Vokke.
 *  All Rights Reserved
 *
 *  This file was developed by Vokke and is only to be used by a person or legal
 *  entity when expressly granted a license to do so through written means.
 *
 *  Unauthorized usage, sharing or copying of this file, via any medium is
 *  strictly prohibited. Proprietary and confidential. This license header
 *  is not to be removed.
 *
 */

import { KernelRoute, KernelRouteEndpoint } from "./routing";
import { Application } from "./application";

/** We merge all of the kernel abstraction layer into a single object and export it **/
export { Application, KernelRoute, KernelRouteEndpoint };



// WEBPACK FOOTER //
// ./public/kernel/abstraction/abstraction.js